import { treatmentZodSchema } from "@redotech/redo-model/split";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";
import { treatmentRequestSchema } from "./create-treatment";

export const updateTreatment = {
  name: "updateTreatment" as const,
  input: treatmentRequestSchema.extend({
    splitId: zExt.objectId(),
    treatmentId: zExt.objectId(),
  }),
  output: z.object({ treatment: treatmentZodSchema }),
};

export type UpdateTreatmentInput = z.infer<typeof updateTreatment.input>;
